export enum Alignments {
  LEFT = 'align-left',
  RIGHT = 'align-right',
}

export enum TextDirection {
  LEFT = 'left',
  RIGHT = 'right',
}
